import { currencies } from '../constants';

export const pushItemImageSelectedDataLayer = (
  items: Record<string, any>[],
) => {
  dataLayer.push({
    event: 'minipdp_item_image_selected',
    list_id: 'quick_view',
    list_name: 'Quick View',
    ecommerce: {
      currency: currencies[ENVIRONMENT_REGION],
      value: 0,
      items,
    },
    event_location: 'Quick-View',
  });
};
